import PropTypes from "prop-types";
import cn from "classnames";

function Dropdown({
  className = "",
  disabled = false,
  hideLabel = false,
  htmlAttributes = {},
  defaultValue = "",
  onChange = null,
  id,
  label,
  children,
}) {
  return (
    <label htmlFor={id}>
      {!hideLabel && label}
      <select
        aria-label={label}
        className={cn(
          `${className} w-full bg-white border border-black-200 rounded-lg h-10 cursor-pointer pl-4 pr-8 pt-0 pb-0 disabled:cursor-not-allowed disabled:opacity-20`
        )}
        id={id}
        defaultValue={defaultValue}
        onChange={onChange}
        disabled={disabled}
        {...htmlAttributes}
      >
        {children}
      </select>
    </label>
  );
}

Dropdown.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  hideLabel: PropTypes.bool,
  htmlAttributes: PropTypes.shape({}),
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
};

export { Dropdown };
